import {
  resource,
  composeReducers,
} from 'common/store/reducer';

import {
  NAMESPACE,
} from './actions';

export default composeReducers(
  resource.factory(NAMESPACE),
);